import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EditIcon from '@material-ui/icons/Edit';
import { NAME_SPACE } from 'i18n';
import { ViewTable, execConfirmModal, ButtonAdd, ButtonDelete } from 'shared';
import { PATH } from 'app.routes.const';
import { useTobaccoProductsPaginated } from './useTobaccoProductsPaginated';
import { useTobaccoProductsBuildTable } from './useTobaccoProductsBuildTable';
import { useListTobaccoProductsStyles } from './tobaccoProducts.styles';

export function ListTobaccoProducts() {
  const classes = useListTobaccoProductsStyles();
  const { products, getProducts, deleteProducts, errorInfo } = useTobaccoProductsPaginated();
  const { t } = useTranslation(NAME_SPACE.TOBACCO_PRODUCTS);
  const history = useHistory();

  const { rows, headCells } = useTobaccoProductsBuildTable(products, t);
  function handleEdit([productId]) {
    history.push(PATH.TOBACCO_PRODUCTS.EDIT.replace(':id', productId));
  }

  function handleAdd() {
    history.push(PATH.TOBACCO_PRODUCTS.CREATE);
  }

  async function handleDelete(productsToDelete) {
    try {
      await execConfirmModal({
        title: t('common:actions.remove'),
        description:
          productsToDelete.length > 1
            ? t('removeConfirm.message', { length: productsToDelete.length })
            : t('removeConfirm.singularMessage', {
                name: productsToDelete[0].name
              }),
        confirmText: t('common:actions.accept'),
        declineText: t('common:actions.cancel'),
        confirmClassName: classes.buttonAdd,
        declineClassName: classes.buttonDelete
      });
      await deleteProducts(productsToDelete);
    } catch (err) {}
  }

  return (
    <div className={classes.products}>
      <ViewTable
        elevation
        spaced
        errors={errorInfo}
        rows={rows}
        cells={headCells}
        defaultOrderBy={{ property: 'name', direction: 'asc' }}
        mainKey={'name'}
        onFetchData={getProducts}
        totalRows={products.total}
        selectRowWhen={element => element.canBeDeleted}
        serverSidePaging
        emptyText={t('empty')}
        actions={[
          {
            title: t('actions.edit'),
            name: 'edit',
            properties: ['id'],
            label: 'edit this row',
            cb: handleEdit,
            icon: <EditIcon />
          }
        ]}
        toolbar={{
          title: t('name'),
          actions: [
            {
              condition: isAnySelected => !isAnySelected,
              cb: handleAdd,
              component: ButtonAdd
            },
            {
              condition: isAnySelected => isAnySelected,
              resetOnCB: true,
              cb: handleDelete,
              component: ButtonDelete
            }
          ]
        }}
      />
    </div>
  );
}
